import React from 'react';
import './AvatarPicker.css'; // 🧹 add this at the top
import Avatar1 from './avatar1';
import Avatar2 from './avatar2';
import Avatar4 from './avatar4';
import Avatar5 from './avatar5';
import Avatar6 from './avatar6';
import Avatar8 from './avatar8';
import Avatar9 from './avatar9';
import DefaultAvatar from './AvatarDefault';

const avatars = {
  default: DefaultAvatar,
  avatar1: Avatar1,
  avatar2: Avatar2,
  avatar4: Avatar4,
  avatar5: Avatar5,
  avatar6: Avatar6,
  avatar8: Avatar8,
  avatar9: Avatar9
};

const colors = [
  '#cf3535', // Crimson Red
  '#0076CE', // Royal Blue
  '#1bb860', // Emerald Green
  '#C8AF55', // Goldenrod
  '#9370DB', // Lavender Purple
  '#ef809e', // Flamingo Pink
  '#708090', // Slate Gray
  '#a97142', // Deep Teal (small typo fix: no space at end)
];

const AvatarPicker = ({ selectedAvatar, avatarColor, onAvatarChange, onColorChange }) => {
  return (
    <div className="avatar-picker-container">
      <h3 className="selector-color">Select Your Avatar</h3>

      {/* Avatar Grid */}
      <div className="avatar-grid">
        {Object.entries(avatars).map(([key, AvatarComp]) => (
          <div
            key={key}
            onClick={() => onAvatarChange(key)}
            className={`avatar-item ${selectedAvatar === key ? 'selected' : ''}`}
          >
            <AvatarComp color={avatarColor} size={50} />
          </div>
        ))}
      </div>

      {/* Color Options */}
      <h4 className="select-color-change">Select a Color</h4>
      <div className="color-grid">
        {colors.map(c => (
          <div
            key={c}
            className="color-swatch"
            style={{ backgroundColor: c }}
            onClick={() => onColorChange(c)}
          />
        ))}
      </div>

      {/* Preview */}
      <h4>Preview:</h4>
      <div className="preview-container">
        {React.createElement(avatars[selectedAvatar] || DefaultAvatar, { color: avatarColor, size: 150 })}
      </div>
    </div>
  );
};

export default AvatarPicker;
